module.exports = __webpack_public_path__ + "img/ic-white-patrimonio.55f329c7.svg";